/**
 *
 * @param {any} str
 */
function log(str) {
    //console.log(JSON.stringify(str, undefined, 4))
}

/**
 * convert object to string
 * @param {any} obj object
 * @returns {String | undefined}
 */
function obj2str(obj) {
    if (Array.isArray(obj)) {
        return JSON.stringify(
            obj.map(function (idx) {
                return obj2str(idx)
            })
        )
    } else if (typeof obj === "object" && obj !== null) {
        var elements = Object.keys(obj)
            .sort()
            .map(function (key) {
                var val = obj2str(obj[key])
                if (val) {
                    return key + ":" + val
                }
            })

        var elementsCleaned = []
        for (var i = 0; i < elements.length; i++) {
            if (elements[i]) elementsCleaned.push(elements[i])
        }

        return "{" + elementsCleaned.join("|") + "}"
    }

    if (obj) return obj
}

/**
 * clear SSR cache
 */
function clearSSRCache() {
    var info = context.db.deleteMany("ssr", {})
    context.response.header("X-SSR-Cleared", info.removed)
}

/**
 * @param {{ [x: string]: any; }[]} dbObjs
 */
function calculateAverageDynamically(dbObjs) {
    const sumObj = {}
    let count = 0

    dbObjs.forEach((/** @type {{ [x: string]: any; }} */ obj) => {
        accumulate(obj, sumObj)
        count++
    })

    /**
     * @param {{ [x: string]: any; }} sourceObj
     * @param {{ [x: string]: any; }} targetObj
     */
    function accumulate(sourceObj, targetObj) {
        for (const key in sourceObj) {
            if (typeof sourceObj[key] === "number") {
                targetObj[key] = (targetObj[key] || 0) + sourceObj[key]
            } else if (typeof sourceObj[key] === "object" && sourceObj[key] !== null) {
                targetObj[key] = targetObj[key] || {}
                accumulate(sourceObj[key], targetObj[key])
            }
        }
    }

    /**
     * @param {{ [x: string]: any; }} targetObj
     */
    function average(targetObj) {
        for (const key in targetObj) {
            if (typeof targetObj[key] === "number") {
                targetObj[key] = targetObj[key] / count
            } else if (typeof targetObj[key] === "object") {
                average(targetObj[key])
            }
        }
    }

    average(sumObj)
    return sumObj
}

var config = require("../config")
/**
 *
 * @param {HookContext} c
 * @param {string} filename
 * @param {string} locale
 * @returns {string}
 */
function tpl(c, filename, locale) {
    return c.tpl.execute(c.fs.readFile(filename), {
        context: c,
        config: config,
    })
}
const { operatorEmail, operatorName } = require("../config")
const { bkdfApiUrl, tibiServerUrl, wohnerApiUrl } = require("../config-client")
const { createPDF } = require("./pdf")
function sendOperatorRatingMail() {
    if (!context.data) context.data = {}
    let locale = context.request().query("locale")
    locale = locale ? locale : "de-DE"
    context.data.tibiLink = `project/${context.project().id}/collection/rating/edit/${context.data.id}` //projekt ID
    context.smtp.sendMail({
        to: operatorEmail,
        from: operatorEmail,
        fromName: operatorName,
        subject: tpl(context, "templates/operator_rating_subject.de-DE.txt", locale),
        html: tpl(context, "templates/operator_rating_body.de-DE.html", locale),
    })
}

/**
 *
 * @param {HookContext | string} c
 */
function getJwt(c, required = true) {
    let tokenString

    if (typeof c == "string") {
        tokenString = c
    } else {
        const authHeader = c.request().header("Authorization")

        if (!authHeader) {
            if (required) {
                throw {
                    status: 403,
                    error: "missing authorization header",
                    log: false,
                }
            } else {
                return null
            }
        }

        tokenString = authHeader.replace("Bearer ", "")
    }

    if (!tokenString) {
        if (required) {
            throw {
                status: 403,
                error: "token: is empty",
                log: false,
            }
        } else {
            return null
        }
    }

    const token = context.jwt.parse(tokenString, {
        secret: config.jwtSecret,
    })

    if (required && !token.valid) {
        throw {
            status: 403,
            error: "token: " + token.error,
            log: false,
        }
    }

    return token
}

/**
 * call callback with login clains
 *
 * @param {(claims: JWTLoginClaims) => void} callback
 * @param {boolean} required
 * @param {string} apiTokenName
 * @returns {boolean} void if backendAuth
 */
function withAccount(callback, required = true, apiTokenName = null, allowViaRefreshToken = false) {
    if (apiTokenName) {
        const r = context.request()
        if (r.header(apiTokenName)) {
            return
        }
    }

    const backendAuth = context.user.auth()

    if (!backendAuth) {
        // require authorization header with jwt
        let token
        /** @type {JWTLoginClaims} */ // @ts-ignore
        let loginClaims
        try {
            token = getJwt(context, required)
            // @ts-ignore
            loginClaims = token && token.claims
        } catch (e) {
            if (allowViaRefreshToken) {
                const rT = getRefreshToken()
                if (rT?.valid) {
                    /** @type {JWTRefreshClaims} */ // @ts-ignore
                    const refreshClaims = rT.claims
                    const accountId = refreshClaims && refreshClaims.id
                    /** @type {User} */ // @ts-ignore
                    const user = context.db.find("user", {
                        filter: { _id: accountId },
                    })[0]
                    loginClaims = {
                        username: user.username,
                        id: user.id,
                    }
                } else {
                    throw {
                        status: 403,
                        error: "token: invalid refresh token",
                        log: false,
                    }
                }
            } else {
                throw e
            }
        }

        // log(loginClaims)

        if (!loginClaims || !loginClaims.id || !loginClaims.username) {
            if (required) {
                throw {
                    status: 403,
                    error: "token: invalid claims",
                    log: false,
                }
            }
            return false
        }

        callback(loginClaims)
        return true
    }
}
/**
 */
function getRefreshToken() {
    const refreshToken = context.cookie.get("wohnerRefreshToken")
    if (refreshToken) {
        return getJwt(refreshToken, false)
    }
    return null
}

/**
 *
 * @param {number} status
 */

function statusIsValid(status) {
    return !!status && status < 400
}

/**
 *
 *  Base64 encode / decode
 *  http://www.webtoolkit.info/
 *
 **/
var Base64 = {
    // private property
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    // public method for encoding
    encode: function (input) {
        var output = ""
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4
        var i = 0
        input = Base64._utf8_encode(input)
        while (i < input.length) {
            chr1 = input.charCodeAt(i++)
            chr2 = input.charCodeAt(i++)
            chr3 = input.charCodeAt(i++)
            enc1 = chr1 >> 2
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
            enc4 = chr3 & 63
            if (isNaN(chr2)) {
                enc3 = enc4 = 64
            } else if (isNaN(chr3)) {
                enc4 = 64
            }
            output =
                output +
                this._keyStr.charAt(enc1) +
                this._keyStr.charAt(enc2) +
                this._keyStr.charAt(enc3) +
                this._keyStr.charAt(enc4)
        }
        return output
    },
    // public method for decoding
    decode: function (input) {
        var output = ""
        var chr1, chr2, chr3
        var enc1, enc2, enc3, enc4
        var i = 0
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "")
        while (i < input.length) {
            enc1 = this._keyStr.indexOf(input.charAt(i++))
            enc2 = this._keyStr.indexOf(input.charAt(i++))
            enc3 = this._keyStr.indexOf(input.charAt(i++))
            enc4 = this._keyStr.indexOf(input.charAt(i++))
            chr1 = (enc1 << 2) | (enc2 >> 4)
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
            chr3 = ((enc3 & 3) << 6) | enc4
            output = output + String.fromCharCode(chr1)
            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2)
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3)
            }
        }
        output = Base64._utf8_decode(output)
        return output
    },
    // private method for UTF-8 encoding
    _utf8_encode: function (string) {
        string = string.replace(/\r\n/g, "\n")
        var utftext = ""
        for (var n = 0; n < string.length; n++) {
            var c = string.charCodeAt(n)
            if (c < 128) {
                utftext += String.fromCharCode(c)
            } else if (c > 127 && c < 2048) {
                utftext += String.fromCharCode((c >> 6) | 192)
                utftext += String.fromCharCode((c & 63) | 128)
            } else {
                utftext += String.fromCharCode((c >> 12) | 224)
                utftext += String.fromCharCode(((c >> 6) & 63) | 128)
                utftext += String.fromCharCode((c & 63) | 128)
            }
        }
        return utftext
    },
    // private method for UTF-8 decoding
    _utf8_decode: function (utftext) {
        var string = ""
        var i = 0
        var c = 0
        var c1 = 0
        var c2 = 0
        var c3 = 0
        while (i < utftext.length) {
            c = utftext.charCodeAt(i)
            if (c < 128) {
                string += String.fromCharCode(c)
                i++
            } else if (c > 191 && c < 224) {
                c2 = utftext.charCodeAt(i + 1)
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63))
                i += 2
            } else {
                c2 = utftext.charCodeAt(i + 1)
                c3 = utftext.charCodeAt(i + 2)
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63))
                i += 3
            }
        }
        return string
    },
}

function filterValidObjects(array) {
    return array.filter((object) => {
        for (let key in object) {
            if (typeof object[key] !== "string" && object[key] !== null) {
                return false
            }
        }
        return true
    })
}

/**
 *
 * @param {any} oldObj
 * @param {any} newObj
 * @param {string} path
 * @returns
 */
function getUpdateLogs(oldObj = {}, newObj = {}, path = "") {
    /**
     * @type {ProtocolAction[]}
     */
    let updateLogs = []
    const ignoredKeys = ["id", "insertTime", "updateTime", "updateLogs"]
    const allKeys = new Set([...Object.keys(oldObj), ...Object.keys(newObj)])

    allKeys.forEach((key) => {
        if (ignoredKeys.includes(key)) return

        const newPath = path ? `${path}.${key}` : key
        const oldVal = oldObj.hasOwnProperty(key) ? oldObj[key] : ""
        const newVal = newObj.hasOwnProperty(key) ? newObj[key] : ""

        // Handle Arrays
        if (oldVal instanceof Date || newVal instanceof Date) {
        } else if (Array.isArray(oldVal) || Array.isArray(newVal)) {
            const oldArr = oldVal || []
            const newArr = newVal || []

            for (let i = 0; i < Math.max(oldArr.length, newArr.length); i++) {
                const itemPath = `${newPath}[${i}]`

                if (oldArr[i] !== newArr[i]) {
                    if (typeof oldArr[i] === "object" || typeof newArr[i] === "object") {
                        const arrUpdates = getUpdateLogs(oldArr[i], newArr[i], itemPath)
                        updateLogs = updateLogs.concat(arrUpdates)
                    } else {
                        updateLogs.push({
                            field: itemPath,
                            previous: oldArr[i] === undefined ? "" : oldArr[i]?.toString(),
                            current: newArr[i] === undefined ? "" : newArr[i]?.toString(),
                        })
                    }
                }
            }
        }
        // Handle nested objects but not arrays
        else if (
            ((typeof oldVal === "object" && oldVal !== null) || (typeof newVal === "object" && newVal !== null)) &&
            typeof oldVal !== "function" &&
            typeof newVal !== "function"
        ) {
            const nestedUpdates = getUpdateLogs(oldVal || {}, newVal || {}, newPath)
            updateLogs = updateLogs.concat(nestedUpdates)
        }
        // Handle primitive types
        else if (
            oldVal !== newVal &&
            typeof oldVal !== "function" &&
            typeof newVal !== "function" &&
            (oldVal || newVal)
        ) {
            updateLogs.push({
                field: newPath,
                previous: oldVal?.toString(),
                current: newVal?.toString(),
            })
        }
    })

    return filterValidObjects(updateLogs)
}
function formatDate(dateo) {
    // console.log("formatDate", JSON.stringify(dateo))
    context.debug.dump(dateo)
    if (!dateo) return "--.--.----"
    const date = new Date(dateo)

    // Check if the date is valid
    if (isNaN(date)) {
        throw new Error("Invalid date format")
    }

    // Extract day, month, and year
    const day = String(date.getDate()).padStart(2, "0")
    const month = String(date.getMonth() + 1).padStart(2, "0") // Months are zero-indexed
    const year = date.getFullYear()

    // Format the date in the German format
    return `${day}.${month}.${year}`
}
function formatDateTime(dateo) {
    if (!dateo) return "--.--.----"
    const date = new Date(dateo)
    const day = String(date.getDate()).padStart(2, "0")
    const month = String(date.getMonth() + 1).padStart(2, "0") // Months are zero-indexed
    const year = date.getFullYear()
    const hours = String(date.getHours()).padStart(2, "0")
    const minutes = String(date.getMinutes()).padStart(2, "0")
    return `${day}.${month}.${year} ${hours}:${minutes}`
}

function formatDateSecondPrecision(dateo) {
    if (!dateo) return "--.--.----"
    const date = new Date(dateo)
    const day = String(date.getDate()).padStart(2, "0")
    const month = String(date.getMonth() + 1).padStart(2, "0") // Months are zero-indexed
    const year = date.getFullYear()
    const hours = String(date.getHours()).padStart(2, "0")
    const minutes = String(date.getMinutes()).padStart(2, "0")
    const seconds = String(date.getSeconds()).padStart(2, "0")
    return `${day}.${month}.${year} | ${hours}:${minutes}:${seconds}`
}
/**
 *
 * @param {Partial<Protocol>} protocol
 * @returns {Protocol}
 */
function logTaskChanges(protocol) {
    /** @type {Task} */
    // @ts-ignore
    let oldTask = context["currentTask"]
    /** @type {Task} */
    // @ts-ignore
    let currentTask = context.db.find("task", { filter: { _id: context.data.id } })[0]

    let changes = getProtocolChanges(oldTask, currentTask)
    protocol.actions = changes
    //@ts-ignore
    return protocol

    /**
     *
     * @param {Task} oldTask
     * @param {Task} currTask
     * @returns
     */
    function getProtocolChanges(oldTask, currTask) {
        let newUpdateLogs = getUpdateLogs(oldTask, currTask)
        return newUpdateLogs
    }
}

/**
 * @param {BaseTask} task
 */
function createTaskImagesPdf(task) {
    const htmlImagesTemplate = context.fs.readFile("templates/TaskImages.html")
    const htmlImagesSecondaryPageTemplate = context.fs.readFile("templates/TaskImagesSecondary.html")

    const map = context.fs.readFile("templates/map.html")
    const order = context.db.find("order", { filter: { _id: task.orderId } })[0]
    /**
     * @type {any[]}
     */
    let images = []
    /**
     * @type {any[][]}
     */
    const locations = []
    ;(task.images || []).forEach((image, i) => {
        const img = context.db.find("media", {
            filter: {
                _id: image.id,
            },
        })[0]
        if (img && image.inMissionProtocol) {
            const latitude =
                typeof img?.location?.latitude === "number"
                    ? img.location.latitude
                    : img?.location?.latitude != null
                    ? Number(img.location.latitude)
                    : null
            const longitude =
                typeof img?.location?.longitude === "number"
                    ? img.location.longitude
                    : img?.location?.longitude != null
                    ? Number(img.location.longitude)
                    : null

            if (latitude != null && longitude != null && !Number.isNaN(latitude) && !Number.isNaN(longitude)) {
                locations.push([latitude, longitude])
            }

            const url = `${wohnerApiUrl}media/${img.id}/${img.file.src}`
            const author = context.db.find("user", {
                filter: {
                    _id: img.author.id,
                },
            })[0]

            let dateUnFormatted = JSON.stringify(img.insertTime).slice(1, -1)
            dateUnFormatted = dateUnFormatted.replace(/^"|"$/g, "")
            const imgObj = {
                img: url,
                file: (img.file.name || img.file.src.split("file/").pop() || "Unbekannt").substring(0, 20),
                comment: img.comment || "Kein Kommentar",
                date: formatDateSecondPrecision(img.insertTime),
                driver: author ? author.username : "Unbekannt",
                dateUnFormatted: dateUnFormatted,
                coordinates: [
                    latitude != null && !Number.isNaN(latitude) ? `${latitude}` : "Unbekannt",
                    longitude != null && !Number.isNaN(longitude) ? `${longitude}` : "Unbekannt",
                ],
            }
            images.push(imgObj)
        }
    })

    /**
     * @param {any[]} coordinates
     */
    function generateStaticMapImageURL(coordinates) {
        const LIMIT = 56

        function pickEvenPairs(coordinates) {
            const n = coordinates.length
            if (n <= LIMIT) return coordinates

            const pairSize = 2
            const numPairs = LIMIT / pairSize // 28
            const maxStart = n - pairSize // letzter gültiger Startindex

            const selected = []
            let prevStart = -pairSize

            for (let i = 0; i < numPairs; i++) {
                // Zielposition gleichmäßig von 0..maxStart
                const target = (i * maxStart) / (numPairs - 1)
                let start = Math.round(target)

                // Kollisionen vermeiden & Platz für Restpaare lassen
                const minAllowed = prevStart + pairSize
                const maxAllowed = maxStart - (numPairs - 1 - i) * pairSize
                if (start < minAllowed) start = minAllowed
                if (start > maxAllowed) start = maxAllowed

                selected.push(coordinates[start], coordinates[start + 1])
                prevStart = start
            }

            return selected
        }

        // Nutzung:
        if (coordinates.length > LIMIT) {
            coordinates = pickEvenPairs(coordinates)
        }
        // Create the markers string for the URL
        const markers = coordinates
            .map((coord) =>
                coord && coord[0] && coord[1]
                    ? `icon:https://wohner.app/m.png|anchor:center|${coord[1]},${coord[0]}`
                    : ""
            )
            .join("|")

        // Construct the full URL for auto-fitted image
        const url = `https://api.maptiler.com/maps/outdoor-v2/static/auto/${2048}x${2048}@1x.png?key=${
            config.maptilerApiKey
        }&markers=${markers}`
        return url
    }

    const sortedImages = images.sort((a, b) => {
        const dateA = new Date(a.dateUnFormatted).getTime()
        const dateB = new Date(b.dateUnFormatted).getTime()

        return dateA - dateB
    })
    const options = {
        task,
        order,
        images: sortedImages,
        coordImage: generateStaticMapImageURL(locations),
        /**
         * @param {string} date
         */
        getDateFormatted: formatDate,
    }
    const limitedImages = sortedImages.slice(0, 200)
    const htmlTaskImages = context.tpl.execute(htmlImagesTemplate, {
        ...options,

        images: limitedImages.slice(0, 32),
    })

    const result = []
    result.push(htmlTaskImages)
    for (let start = 32; start < limitedImages.length; start += 32) {
        const secondaryPage = context.tpl.execute(htmlImagesSecondaryPageTemplate, {
            ...options,
            images: limitedImages.slice(start, start + 32),
        })
        result.push(secondaryPage)
    }

    const mapHtml = context.tpl.execute(map, { ...options })
    result.push(mapHtml)
    return result
}

/**
 * @param {BaseTask} task
 */
function createTaskReportPdf(task) {
    const htmlReportTemplate = context.fs.readFile("templates/TaskReport.html")
    const order = context.db.find("order", { filter: { _id: task.orderId } })[0]
    const protocolEvents = (task.manualProtocol?.entries || [])
        .map((entry, i) => {
            if (!entry.eventId) return
            const eventObj = context.db.find("option", {
                filter: {
                    _id: entry.eventId,
                },
            })
            return {
                originalDate: entry.datetime,
                date: formatDateTime(entry.datetime),
                description: eventObj[0]?.name || "Unbekannt - Fehler!",
            }
        })
        ?.filter(Boolean)
        .sort((a, b) => {
            if (!a.originalDate && !b.originalDate) return 0 // If both have no date, they are equal
            if (!a.originalDate) return 1 // If a has no date, b is later
            const stringA = JSON.stringify(a.originalDate).slice(1, -1)
            const dateA = new Date(stringA).getTime()
            if (!b.originalDate) return -1 // If b has no date, a is earlier
            const stringB = JSON.stringify(b.originalDate).slice(1, -1)
            const dateB = new Date(stringB).getTime()
            return dateA - dateB
        })
    const htmlTaskReport = context.tpl.execute(htmlReportTemplate, {
        task,
        order,
        items: protocolEvents,
        /**
         * @param {string} date
         */
        getDateFormatted: formatDate,
    })
    return htmlTaskReport
}

/**
 * @param {TaskOilSpillRemoval} task
 */
function createTaskProtocolPdf(task) {
    const htmlProtocolTemplate = context.fs.readFile("templates/TaskProtocol.html")

    /** @type {HookException} */
    const hEx = {}
    const actions = [
        "accidentSceneCleanup",
        "soilAndWaterRemediation",
        "measurement",
        "trafficAreaCertificateOrOilRemoval",
    ]
    const weatherConditions = ["dry", "wet", "moist", "rain", "snow", "sun"]
    const alarmingGroups = ["Polizei", "Feuerwehr", "Rettungsleitstelle", "Kommune", "Halter", "Fahrer"]
    const underground = ["Asphalt", "Pflaster", "Beton"]
    const additionalUnderground = (task?.damageDetails?.underground?.types || [])?.filter(
        (group) => !underground.includes(group)
    )
    const substances = ["Benzin", "Diesel", "Beton", "Motoröl", "Kühlwasser", "Ölhaltige BS"]
    const additionalSubstances = (task?.damageDetails?.leakedSubstances?.types || [])?.filter(
        (group) => !substances.includes(group)
    )
    const causes = ["Unfall", "Wildunfall", "Technischer Defekt", "Verlorene Ladung"]
    const additionalCauses = (task?.damageDetails?.causes?.types || [])?.filter((group) => !causes.includes(group))
    const additionalAlarmingGroups = (task?.details?.alarmingInstitutions || [])?.filter(
        (group) => !alarmingGroups.includes(group)
    )
    const vehicles = []
    ;(task?.vehicles?.vehicleObjects || []).forEach((vehicle, i) => {
        if (!vehicle || !vehicle?.driver?.id) return
        else
            vehicles.push({
                nr: i + 1,
                driver:
                    vehicle?.driver?.id &&
                    context.db.find("user", {
                        filter: {
                            _id: vehicle.driver.id,
                        },
                    })[0],
                coDriver:
                    vehicle?.coDriver?.id &&
                    context.db.find("user", {
                        filter: {
                            _id: vehicle.coDriver.id,
                        },
                    })[0],
                vehicle:
                    (vehicle?.vehicle?.id &&
                        context.db.find("vehicle", {
                            filter: {
                                _id: vehicle.vehicle.id,
                            },
                        })[0]) ||
                    {},
                equipment:
                    vehicle?.equipment?.id &&
                    context.db.find("vehicle", {
                        filter: {
                            _id: vehicle.equipment.id,
                        },
                    })[0],
            })
    })
    const additionalEquipmentDB = context.db.find("equipment")
    const additionalEquipment = []
    const additionalEquipmentIds = []
    additionalEquipmentDB.forEach((vehicle) => {
        additionalEquipment.push(vehicle.name)
        additionalEquipmentIds.push(vehicle.id)
    })
    const additionalCustomEquipment = (task?.vehicles?.additionalEquipment?.ids || []).filter(
        (vehicle) => !additionalEquipmentIds?.includes(vehicle)
    )
    const order = context.db.find("order", { filter: { _id: task.orderId } })[0]

    const usageMaterials = context.db.find("option", { filter: { category: "utillityMaterial" } })
    const usages = usageMaterials?.map((material, i) => {
        const amount = (task?.usages || []).find((usage) => usage.name == material.name)?.amount

        return {
            name: material.name,
            unit: String(material.additionalInfos.unit).toUpperCase(),
            amount: Number((amount || 0).toFixed(2)),
            nr: i + 1,
        }
    })
    const additionalUsages = (task.usages || [])
        .filter((usage) => !(usageMaterials || [])?.map((material) => material.name).includes(usage.name))
        .map((el, i) => {
            return {
                name: el.name,
                unit: String(el?.unit).toUpperCase(),
                amount: Number((el?.amount || 0).toFixed(2)),
                nr: usages.length + i + 1,
            }
        })
        .filter((usage) => usage.amount > 0)

    const areas = (task.cleanedAreas || [])
        .filter((area) => area.length > 0 || area.width > 0 || area.depth > 0)
        .map((area, i) => {
            return { nr: i + 1, ...area }
        })
    areas.forEach((area) => {
        if (isNaN(area.length) || !area.length) area.length = 0
        if (isNaN(area.width) || !area.width) area.width = 0
        if (isNaN(area.depth) || !area.depth) area.depth = 0
    })
    const disposalMaterials = context.db.find("option", { filter: { category: "disposableMaterial" } })
    const disposals = disposalMaterials
        .map((material, i) => {
            const disposal = task?.pollutionDetails?.disposals?.find((disposal) => disposal?.materialId == material?.id)
            if (!disposal) return null
            const obj = {
                ...disposal,
                name: material.name,
                unit:
                    material.additionalInfos.unit == "kgOnm2"
                        ? "KG"
                        : String(material?.additionalInfos?.unit).toUpperCase(),
                amount: Number((disposal?.amount || 0).toFixed(2)),
                nr: i + 1,
                type: material.additionalInfos.unit == "kgOnm2" ? "area" : "amount",
            }
            if (isNaN(obj.width) || !obj.width) obj.width = 0
            if (isNaN(obj.length) || !obj.length) obj.length = 0
            return obj
        })
        .filter((disposal) => Boolean(disposal))
    const additionalDisposals = task?.pollutionDetails?.disposals
        ?.filter((disposal) => !disposalMaterials.map((material) => material.id).includes(disposal.materialId))
        ?.map((el, i) => {
            const disposal = context.db.find("option", { filter: { _id: el.materialId } })[0]
            return {
                nr: disposals.length + i + 1,
                ...disposal,
                ...el,
                unit:
                    disposal.additionalInfos.unit == "kgOnm2"
                        ? "KG"
                        : String(disposal.additionalInfos.unit).toUpperCase(),
                type: disposal.additionalInfos.unit == "kgOnm2" ? "area" : "amount",
            }
        })

    function formatNumberToTwoDigit(number) {
        if (!number) number = 0
        const n = Number(number)
        return n < 10 ? `${n.toFixed(2)}` : n.toFixed(2)
    }
    if (task?.details?.diaryNumber) {
        task.details.diaryNumber = task.details.diaryNumber.toFixed(0)
    }

    if (!task?.timeframe) {
        task.timeframe = {}
    }
    if (!task?.timeframe?.start) {
        task.timeframe.start = ""
    }
    if (!task?.timeframe?.end) {
        task.timeframe.end = ""
    }
    const htmlTaskProtocol = context.tpl.execute(htmlProtocolTemplate, {
        task,
        actions,
        order,
        weatherConditions,
        alarmingGroups,
        additionalAlarmingGroups,
        underground,
        additionalUnderground,
        substances,
        additionalSubstances,
        causes,
        additionalCauses,
        vehicles,
        additionalEquipment,
        additionalCustomEquipment,
        usages,
        additionalUsages,
        areas,
        disposals,
        additionalDisposals,

        /**
         * @param {"action" | "weatherCondition"} type
         * @param {any} value
         */
        getGermanEquivalent: function (type, value) {
            if (type == "action") {
                switch (value) {
                    case "accidentSceneCleanup":
                        return "Unfallstellenreinigung"
                    case "soilAndWaterRemediation":
                        return "Boden- und Wassersanierung"
                    case "measurement":
                        return "Messung"
                    case "trafficAreaCertificateOrOilRemoval":
                        return "Verkehrsflächenreinigung / Ölspurbeseitigung"
                }
            } else if (type == "weatherCondition") {
                switch (value) {
                    case "dry":
                        return "trocken"
                    case "wet":
                        return "nass"
                    case "moist":
                        return "feucht"
                    case "rain":
                        return "Regen"
                    case "snow":
                        return "Schnee"
                    case "sun":
                        return "Sonne"
                }
            }
        },
        /**
         * @param {string} date
         */
        getDateFormatted: formatDate,
        /**
         *
         * @param {Number | String} number
         * @returns
         */
        formatNumberToTwoDigit: formatNumberToTwoDigit,
    })

    const htmlTaskReport = createTaskReportPdf(task)
    const htmlTaskImages = createTaskImagesPdf(task)
    const objImageList = htmlTaskImages.map((html) => ({ html }))
    context.response.header("Content-Type", "application/pdf")
    context.response.header("Content-Disposition", 'inline; filename="offer.pdf"')
    hEx.status = 200
    hEx.bytes = createPDF([{ html: htmlTaskProtocol }, { html: htmlTaskReport }, ...objImageList])
    hEx.log = false
    throw hEx
}
/**
 * @param {TaskOilSpillRemoval} task
 */
function createTaskNotificationPdf(task) {
    const htmlTaskNotificationTemplate = context.fs.readFile("templates/TaskNotification.html")
    const order = context.db.find("order", { filter: { _id: task.orderId } })[0]
    order.generalDetails.number = String(order.generalDetails.number.toFixed(0))
    let contactPerson
    if (task.meta.createdBy) {
        contactPerson = context.db.find("user", { filter: { _id: task.meta.contactPerson.id } })[0]
    } else {
        contactPerson = {
            username: "Unbekannt",
            email: "Unbekannt",
            phone: "Unbekannt",
            lastName: "Unbekannt",
            firstName: "Unbekannt",
        }
    }
    const htmlTaskNotification = context.tpl.execute(htmlTaskNotificationTemplate, {
        order,
        task,
        contactPerson,
        /**
         * @param {string} date
         */
        getDateFormatted: formatDate,
        formatDateTime,
        formatDateTimePlusOne: function (dateo) {
            // do it
            let datestring = JSON.stringify(dateo).slice(1, -1)
            //remove beginning and trainilg "
            datestring = datestring.replace(/^"|"$/g, "")
            const date = new Date(datestring)
            date.setHours(date.getHours() + 1)
            const day = String(date.getDate()).padStart(2, "0")
            const month = String(date.getMonth() + 1).padStart(2, "0") // Months are zero-indexed
            const year = date.getFullYear()
            const hours = String(date.getHours()).padStart(2, "0")
            const minutes = String(date.getMinutes()).padStart(2, "0")
            return `${day}.${month}.${year} ${hours}:${minutes}`
        },
    })
    context.response.header("Content-Type", "application/pdf")
    context.response.header("Content-Disposition", 'inline; filename="notification.pdf"')
    const hEx = {}
    hEx.status = 200
    hEx.bytes = createPDF([{ html: htmlTaskNotification }])
    hEx.log = false

    throw hEx
}

/**
 * @param {TaskOilSpillRemoval} task
 */
function createTaskTowingPdf(task) {
    const htmlTaskTowingTemplate = context.fs.readFile("templates/TowingProtocol.html")
    const order = context.db.find("order", { filter: { _id: task.orderId } })[0]
    order.generalDetails.number = String(order.generalDetails.number.toFixed(0))
    if (!task?.timeframe) {
        task.timeframe = {}
    }
    if (!task?.timeframe?.start) {
        task.timeframe.start = ""
    }
    if (!task?.timeframe?.end) {
        task.timeframe.end = ""
    }
    const htmlTaskTowing = context.tpl.execute(htmlTaskTowingTemplate, {
        order,
        task,
        /**
         * @param {string} date
         */
        getDateFormatted: formatDate,
        formatDateTime,
        formatDateTimePlusOne: function (dateo) {
            // do it
            let datestring = JSON.stringify(dateo).slice(1, -1)
            //remove beginning and trainilg "
            datestring = datestring.replace(/^"|"$/g, "")
            const date = new Date(datestring)
            date.setHours(date.getHours() + 1)
            const day = String(date.getDate()).padStart(2, "0")
            const month = String(date.getMonth() + 1).padStart(2, "0") // Months are zero-indexed
            const year = date.getFullYear()
            const hours = String(date.getHours()).padStart(2, "0")
            const minutes = String(date.getMinutes()).padStart(2, "0")
            return `${day}.${month}.${year} ${hours}:${minutes}`
        },
    })
    const htmlTaskImages = createTaskImagesPdf(task)
    const htmlTaskReport = createTaskReportPdf(task)
    const objImageList = htmlTaskImages.map((html) => ({ html }))
    context.response.header("Content-Type", "application/pdf")
    context.response.header("Content-Disposition", 'inline; filename="towing.pdf"')
    const hEx = {}
    hEx.status = 200
    hEx.bytes = createPDF([{ html: htmlTaskTowing }, { html: htmlTaskReport }, ...objImageList])
    hEx.log = false
    throw hEx
}

module.exports = {
    log,
    clearSSRCache,
    obj2str,
    calculateAverageDynamically,
    sendOperatorRatingMail,
    getJwt,
    withAccount,
    getRefreshToken,
    statusIsValid,
    Base64,
    getUpdateLogs,
    logTaskChanges,
    createTaskProtocolPdf,
    createTaskNotificationPdf,
    createTaskTowingPdf,
}
